import { EventManager } from '../core/EventManager';
import { SystemState } from '../core/SystemState';
import { POI } from './POI';

export class POISystemState extends SystemState {
    private _activePOI: POI | null = null;

    constructor(eventManager: EventManager) {
        super(eventManager);
    }

    public get activePOI(): POI | null {
        return this._activePOI;
    }

    public setActivePOI(newPOI: POI | null): void {
        if (this._activePOI === newPOI) return;

        const oldPOI = this._activePOI;
        this._activePOI = newPOI;

        // Update active state on POIs (this triggers video play/pause)
        if (oldPOI) {
            oldPOI.setActive(false);
        }
        if (newPOI) {
            newPOI.setActive(true);
        }

        ////console.log(`Active POI changed from ${oldPOI?.name ?? 'none'} to ${newPOI?.name ?? 'none'}`);
        this._eventManager.emit('poi:active-changed', { newPOI, oldPOI });
    }
} 